"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var recompose_1 = require("recompose");
exports.formWrapper = recompose_1.mapProps(function (formProps) {
    var input = formProps.input, meta = formProps.meta, rest = __rest(formProps, ["input", "meta"]);
    return __assign({ errorText: meta.touched && meta.error, value: input.value, onChange: input.onChange, name: input.name }, rest);
});
exports.arrayWrapper = recompose_1.mapProps(function (formProps) {
    var input = formProps.input, meta = formProps.meta, rest = __rest(formProps, ["input", "meta"]);
    return __assign({ errorText: meta.touched && meta.error, value: input.value || [], onChange: input.onChange, name: input.name }, rest);
});
exports.nullWrapper = recompose_1.mapProps(function (formProps) {
    var input = formProps.input, meta = formProps.meta, rest = __rest(formProps, ["input", "meta"]);
    return __assign({ errorText: meta.touched && meta.error, value: input.value || null, onChange: input.onChange, name: input.name }, rest);
});
exports.booleanWrapper = recompose_1.mapProps(function (formProps) {
    var input = formProps.input, meta = formProps.meta, rest = __rest(formProps, ["input", "meta"]);
    return __assign({ errorText: meta.touched && meta.error, value: !!input.value, onChange: input.onChange, name: input.name }, rest);
});
//# sourceMappingURL=reduxFormWrappers.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/reduxFormWrappers.js
// module id = 83
// module chunks = 0